export default "__VITE_ASSET__154254ea__"